import React from 'react';
import { Modal, Container, Row, Col, Image } from 'react-bootstrap';
import image from '../../Media/logo.png';
import { connect } from 'react-redux';
import GoogleAuth from './googleAuth';
import history from '../../history';
import packageJson from '../../../package.json';

class ingreso extends React.Component {

    componentDidUpdate() {

        if (this.props.isSignedIn) {
            history.push('/home');
            return;
        }
    }

    render() {
        return (
            <Modal show={true} aria-labelledby="contained-modal-title-vcenter" className="centerLogIn">
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter"  >
                        Bienvenido a tu app Uitaca
                        </Modal.Title>
                </Modal.Header>
                <Modal.Body className="show-grid">
                    <Container>
                        <Row >
                            <Col xs={1} lg="3"></Col>
                            <Col xs={8} md={8} lg="2">
                                <Image alt='Hupity tu compañero en el trabajo' src={image} rounded />
                            </Col>
                        </Row>
                        <Row>
                            <Col  xs={{offset: 1}}>
                                <h4>Ingresa con tu correo para entrar.</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={{offset: 8}} xs={{offset: 6}} >
                                <p>  Version :  {packageJson.version}</p>
                            </Col>
                        </Row>
                      
                    </Container>
                </Modal.Body>
                <Modal.Footer  >
                    <GoogleAuth />
                </Modal.Footer>
            </Modal>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.mainReducer.isSignedIn,
    }
};
export default connect(mapStateToProps, {})(ingreso);



